<template>
  <div class="container">
    <div class="finance-list-body">
      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="grid-content bg-purple-dark">
            <div>
              <el-input
                size="small"
                placeholder="请输入内容"
                v-model="form.search_value"
              >
                <template slot="prepend">
                  <el-select
                    size="small"
                    v-model="form.search_type"
                    slot="prepend"
                    placeholder="请选择"
                    style="width: 130px"
                  >
                    <el-option label="学员姓名" value="1"></el-option>
                    <el-option label="学员账号" value="2"></el-option>
                    <el-option label="家长电话" value="3"></el-option>
                  </el-select>
                </template>
              </el-input>
            </div></div
        ></el-col>

        <el-col :span="10"
          ><div class="grid-content bg-purple-dark">
            <el-date-picker
              size="small"
              v-model="startOrEndTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              placement="bottom-start"
            >
            </el-date-picker></div
        ></el-col>

        <el-col :span="6"
          ><div class="grid-content bg-purple-dark">
            <el-button size="small" type="primary" @click="onSubmitSelect"
              >查询</el-button
            >
            <el-button size="small" @click="reSize">重置</el-button>
          </div></el-col
        >
      </el-row>

      <el-divider></el-divider>

      <el-row>
        <el-col :span="24"
          ><div class="submit_info">
            <el-table
              size="small"
              border
              ref="singleTable"
              :data="tableData"
              highlight-current-row
              @current-change="handleCurrentChange"
              style="width: 100%"
              :header-cell-style="{ background: '#f5f7fa' }"
            >
              <el-table-column
                align="center"
                property="created_time"
                label="订单时间"
                width="150"
              >
              </el-table-column>

              <el-table-column
                align="center"
                property="date"
                label="平台账号"
                width="150"
              >
                <template slot-scope="scope">
                  {{ scope.row.studentInfo.name }} </template
                >>
              </el-table-column>

              <el-table-column
                align="center"
                property="date"
                label="学员姓名"
                width="150"
              >
                <template slot-scope="scope">
                  {{ scope.row.studentInfo.nickname }} </template
                >>
              </el-table-column>

              <el-table-column
                align="center"
                prop="phone"
                label="所属科目"
                width="150"
              >
                <template slot-scope="scope">
                  <div v-for="item in scope.row.courseGoodsArr" :key="item.id">
                    <span> {{ item.name }}</span>
                    <br />
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                prop="phone"
                label="课程体系"
                width="150"
              ></el-table-column>

              <el-table-column
                align="center"
                prop="name"
                label="报名班级"
                width="200"
              >
                <template slot-scope="scope">
                  <div v-for="item in scope.row.courseGoodsArr" :key="item.id">
                    <span> {{ item.name }}</span>
                    <br />
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                prop="phone"
                label="订单商品"
                width="200"
              >
                <template slot-scope="scope">
                  <div v-for="item in scope.row.otherGoodsArr" :key="item.id">
                    <span> {{ item.name }} x {{ item.sell_out_num }}</span>
                    <br />
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                prop="total_amount"
                label="订单金额(元)"
                width="150"
              ></el-table-column>

              <el-table-column
                align="center"
                prop="remark"
                label="备注"
                width="200"
              ></el-table-column>
            </el-table></div
        ></el-col>
      </el-row>

      <div style="margin-top: 30px; text-align: right">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-size="20"
          layout="total,prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderList } from '@/api/educational'

export default {
  name: 'financeList',
  data() {
    return {
      form: {
        search_type: '1',
        search_value: '',
        start_time: '',
        end_time: '',
      },
      tableData: [],

      page_no: '1',
      page_size: '20',
      total: '',

      name: '',
      selectType: '1',
      stateId: '1',
      startOrEndTime: [],
      currentPage: 1,
      formInline: {
        user: '',
        region: '',
      },
      financeTableData: [
        {
          id: 1,
          orderId: '159601685700001',
          createTime: '2020-07-29 18:00:57',
          studentName: '周航',
          phoneNum: '18201133075',
          orderStateStr: '已取消',
          productTypeStr: '课程-长期课',
          goodsName: '重庆演示3阶思维创新-冲刺班',
          unitPrice: 0,
          goodsNum: 1,
          goodsTotal: 1111,
          orderTotal: 11112,
        },
        {
          id: 2,
          orderId: '159601685700001',
          createTime: '2020-07-29 18:00:57',
          studentName: '周航',
          phoneNum: '18201133075',
          orderStateStr: '已取消',
          productTypeStr: '课程-长期课',
          goodsName: '重庆演示3阶思维创新-冲刺班',
          unitPrice: 0,
          goodsNum: 1,
          goodsTotal: 1111,
          orderTotal: 11112,
        },
      ],
    }
  },

  mounted() {
    this.getOrderList()
  },

  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_no = val
      this.getOrderList()
    },
    reSize() {
      console.log('重置')
      this.form = {
        search_type: '1',
        search_value: '',
        start_time: '',
        end_time: '',
      }
      this.startOrEndTime = []
      this.getOrderList()
    },
    onSubmitSelect() {
      console.log('提交查询')
      if (this.startOrEndTime.length > 0) {
        this.form.start_time = this.startOrEndTime[0]
        this.form.end_time = this.startOrEndTime[1]
      }

      console.log(this.form)
      console.log(this.startOrEndTime)

      this.getOrderList()
    },
    gotoRefund(obj) {
      this.$router.push({
        name: 'refund',
        query: {
          id: obj.id,
        },
      })
    },
    gotoFinanceContent(obj) {
      this.$router.push({
        name: 'finance-content',
        query: {
          id: obj.id,
        },
      })
    },

    // 获取订单列表
    getOrderList() {
      getOrderList({
        search_type: this.form.search_type,
        search_value: this.form.search_value,
        start_time: this.form.start_time,
        end_time: this.form.end_time,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询所有订单')
        console.log(res)
        this.tableData = res.orderList
        this.total = res.total
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  overflow: hidden;
  .finance-list-body {
    padding: 20px;
    margin: 15px;
    border-radius: 5px;
    background-color: #ffffff;
    .label-title {
      font-size: 14px;
    }
    .search-list {
      margin-top: 20px;
      display: inline-block;
      margin-left: 16px;
    }
    .el-select .el-input {
      width: 130px;
    }
  }
}
</style>
